'use client';

import {
	BigNum,
	QUOTE_PRECISION_EXP,
	SpotMarketConfig,
	WRAPPED_SOL_MINT,
} from '@velocity-exchange/sdk';
import { useMemo } from 'react';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import useSPLTokenBalance from './useSPLTokenBalance';

const useCurrentWalletCollateralBalance = (
	market: SpotMarketConfig | undefined
) => {
	const decimals = market?.precisionExp.toNumber();
	const [splTokenBalance, loading] = useSPLTokenBalance(market?.mint, decimals);

	const solBalance = useVelocityStore((s) => s.wallet.currentSolBalance);

	const isSolBank = !!market?.mint.equals(WRAPPED_SOL_MINT);

	const result: [BigNum, boolean] = useMemo(() => {
		if (!market) {
			return [BigNum.zero(QUOTE_PRECISION_EXP), false];
		}

		const splTokenBalanceBigNum = BigNum.fromPrint(
			splTokenBalance ? splTokenBalance.toString() : '0',
			market.precisionExp
		);

		const balanceToReturn = isSolBank ? solBalance : splTokenBalanceBigNum;
		const loadingToReturn = isSolBank ? false : loading;

		return [balanceToReturn, loadingToReturn];
	}, [isSolBank, market, solBalance.toNum(), splTokenBalance, loading]);

	return result;
};

export default useCurrentWalletCollateralBalance;
